import React from "react";
import LinkWithSearchParams from "../../../Components/UI/LinkWithSearchParams";
import { getEllipsisTxt } from "../../../helpers/formatters";
import { SiTarget } from "react-icons/si";
import Countdown, { zeroPad } from "react-countdown";

const LiquidityLockerCards = (props) => {
    const { logo, name, endOfLockTime, owner, time, lockerLP } = props;

    // Renderer callback with condition
    const renderer = ({ days, hours, minutes, seconds, completed }) => {
        // Render a countdown
        return (
            <div className="flex gap-1">
                <span className="flex size-sm items-center justify-center bg-kadItemDarkBg rounded w-8 h-7">
                    {zeroPad(days)}
                </span>
                <span className="flex size-sm items-center justify-center bg-kadItemDarkBg rounded w-8 h-7">
                    {zeroPad(hours)}
                </span>
                <span className="flex size-sm items-center justify-center bg-kadItemDarkBg rounded w-8 h-7">
                    {zeroPad(minutes)}
                </span>
                <span className="flex size-sm items-center justify-center bg-kadItemDarkBg rounded w-8 h-7">
                    {zeroPad(seconds)}
                </span>
            </div>
        );
    };
    return (
        <div className="flex flex-col gap-1">
            <LinkWithSearchParams
                to={{ pathname: `/liquidity/${lockerLP}` }}
                className="flex flex-col group relative justify-center items-center"
            >
                <img
                    src={logo}
                    alt="ProfilePicture"
                    className="w-full aspect-square card-component"
                />
                <button className="absolute px-4 bottom-0 group-hover:bottom-4 right-12 opacity-0 duration-150 group-hover:opacity-100 blueGradient-button">
                    <SiTarget className="mr-1" /> View
                </button>
            </LinkWithSearchParams>
            <span className="py-2 size-1">{name}</span>
            <div className="flex flex-col mx-2 size-sm w-full font-normal">
                <div className="flex flex-row w-full justify-between">
                    <span>Unlock At</span>
                    <span>{endOfLockTime}</span>
                </div>
                <div className="flex flex-row w-full justify-between items-center mt-3">
                    <span>Owner</span>
                    <span>{getEllipsisTxt(owner)}</span>
                </div>
            </div>
            <div className="bg-opacity-50 dark:bg-opacity-50 bg-black dark:bg-white h-[1px] w-full my-3" />
            <div className="flex flex-row justify-between w-full">
                <span>Remaining </span>
                <Countdown date={time * 1000} renderer={renderer} />
            </div>
        </div>
    );
};
export default LiquidityLockerCards;
